const isLoggedIn = state => !!state.token;
const getToken = state => state.token;
const getUserRole = state => state.userRole;
const getUserInfo = state => state.userInfo;
const isImpersonating = state => !!state.impersonator;

export default {
    isLoggedIn,
    getToken,
    getUserRole,
    getUserInfo,
    isImpersonating
}